import { styled } from "@mui/material"

export const ErrorText = styled("div")({
  color: "#CF4444",
  display: "flex",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "16px",
  textWrap: "nowrap"
})
